package gr.tech.pdfgenerator.infrastructure.pdf

import kotlinx.browser.window
import kotlinx.browser.document
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLElement
import org.w3c.files.Blob

/*
    HTML2PDF NOTES:

    Possible to fail with 'Too Many Pages' error -
    The error is from the HTML canvas element getting too big (px Height in this case).
    See: https://github.com/eKoopmans/html2pdf.js/issues/19
*/

private val scope = MainScope()

enum class PDFGenStatus {
    GENERATING,
    DOWNLOADING,
    BLOB_READY,
    READY_DOWNLOAD,
    DOWNLOADED,
    FAILED,
}

class GeneratePDFTool {
    var pdfInstance: dynamic = null

    fun genPDF(
        onGenerationStatus: (PDFGenStatus) -> Unit,
    ) {
        try {
            console.log("Starting PDF Generation 1")
            scope.launch {
                console.log("Starting PDF Generation 2")
                window.setTimeout({
                    console.log("Starting PDF Generation 3")
                    val element = document.getElementById("element-to-print") as HTMLElement?
                    console.log("Reaching element: ${element?.id}")
                    if (element != null) {
                        val instance = js( code =
                            """
                                html2pdf()
                                    .from(element)
                                    .set({
                                        filename: document.title + '.pdf',
                                        image: { type: 'jpeg', quality: 0.95 },
                                        html2canvas: {
                                            logging: false,
                                            scale: 1.75, 
                                            scrollY: 0, 
                                            letterRendering: true,
                                        },
                                        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait', compress: true }
                                    })
                            """
                        )

                        // Literally saving this from JS into our KotlinJS code!
                        js("this.pdfInstance = instance")
                        console.log("Reaching here")
                        instance.then {
                            onGenerationStatus(PDFGenStatus.READY_DOWNLOAD)
                        }
                    } else {
                        onGenerationStatus(PDFGenStatus.FAILED)
                        console.warn("Element to print not found")
                    }
                }, 500)
            }
        } catch (e: Exception) {
            console.error("GenPDF Error: $e")
            onGenerationStatus(PDFGenStatus.FAILED)
        }
    }

    fun downloadPDFtoBrowser(onError: () -> Unit = {}) {
        console.log("Downloading PDF...")
        val instance = js("pdfInstance") ?: run {
            console.warn("No generated PDF instance found.")
            onError()
            return
        }

        instance.save().catch {
            console.error("Failed to Download PDF!")
            onError()
        }
    }

    fun getBlob(onBlobReady: (Blob) -> Unit, onError: () -> Unit = {}) {
        console.log("Getting PDF blob...")
        val instance = js("pdfInstance") ?: run {
            console.warn("No generated PDF instance found.")
            onError()
            return
        }

        instance.outputPdf("blob").then { blob ->
            onBlobReady(blob as Blob)
        }.catch {
            console.error("Failed to get PDF blob")
            onError()
        }
    }
}